import React, { useState } from "react";
import { DetailTable } from "extranet-component-library";

import warning from '../assets/img/AVISO.svg';
import { parseHeadersTable, parseChildHeaders } from "../utils/parsers";

interface WalletProps {
    movements: Array<any>;
    totalItems: number;
    getMoreData: (page?: number, resultsPerPage?: number) => Promise<void>;
}

const TableWallet = ({ ...props }: WalletProps) => {
    const [expandedRows, setExpandedRows] = useState();

    return (
        <div className="wallet">
            <DetailTable
                items={props.movements}
                headers={parseHeadersTable(props.movements, [
                    "operationDate",
                    "movements",
                    "tripHops",
                    "amount",
                    "totalAmount",
                    "points",
                    "totalPoints",
                    "error",
                ])}
                pagination
                totalItems={props.totalItems}
                rows={10}
                errorImg={warning}
                expandedRows={expandedRows}
                getMoreData={props.getMoreData}
                childHeaders={parseChildHeaders(props.movements)}
                onExpandRow={(data) => setExpandedRows(data)}
            />
        </div>
    );
};

export default TableWallet;
